import ThisModule from "./ZoomProvider";

export default ThisModule;
